'use client';
import ImgBox from '@/components/img-box';
import { Section } from '@/components/screen-scroll';
import { Image } from '@ssv-website/web-ui';
import { CosImage, getCosImageUrl } from '@ssv-website/web-ui';
import React, { LegacyRef, useEffect } from 'react';
import { useSpringCarousel } from '@ssv-website/hooks';
import { animated } from '@react-spring/web';
import { ClientApi } from '@ssv-website/hooks/useApi/useClientApi';
import carousel_arrow_left from './images/carousel-arrow-left.png';
import carousel_arrow_right from './images/carousel-arrow-right.png';
import Link from 'next/link';
//import config from '../preset-config/carousel';
import { getSrc } from '@/utils';
import arrow_line from './images/arrow-line.png';
const CarouselHome = ({
  data,
  config,
}: {
  data: HomePageTypes.Banner[];
  config: any;
}) => {
  const { transitions, inViewRef, onStop, onStart, onNext, onPrev } =
    useSpringCarousel({
      value: 0,
      duration: 4000, // 4000
      total: data ? data.length + 2 : 2,
      // disabled: true,
    });

  const normal = data.map((v, i) => (
    <ItemNormal src={v.image} key={i} link={v.link} />
  ));
  const renderList = [
    <ItemA config={config} key={1} />,
    <ItemB config={config} key={2} />,
    ...normal,
  ];

  return (
    <Section cssContent="py-0" iconType="light">
      <div
        className="w-full flex overflow-hidden h-full relative"
        ref={inViewRef as LegacyRef<HTMLDivElement>}
      >
        {transitions(({ opacity, transform }, i) => (
          <animated.div
            className="w-screen h-full overflow-hidden absolute left-0 top-0"
            key={i}
            style={{ opacity, transform }}
            onMouseEnter={onStop}
            onMouseLeave={onStart}
          >
            {renderList[i]}
          </animated.div>
        ))}
      </div>
      <ArrowGroup onNext={onNext} onPrev={onPrev} />
    </Section>
  );
};
export default CarouselHome;
const ItemA = ({ config }: any) => {
  const source = [...(config?.item_a || []), ...(config?.item_b || [])];
  console.log('🚀 ~ ItemA ~ source:', source);

  return (
    <div className="box-border px-[9.38rem] py-40 flex items-center justify-center h-full relative">
      <Image
        src={getSrc('1732003124830/item_a_bg')}
        alt=""
        fill
        className="object-fit absolute left-0 top-0 -z-10"
      />
      <div className=" h-full flex gap-x-3 max-h-[45rem] aspect-[22/9]">
        <div className="flex flex-col flex-1 gap-y-3">
          <div className="flex-1 overflow-hidden">
            <ImgBox {...source[0]} />
          </div>
          <div className="flex-1 flex gap-x-3 overflow-hidden">
            <ImgBox className="flex-1" {...source[1]} />
            <ImgBox className="flex-1" {...source[2]} />
          </div>
        </div>
        <div className="flex flex-1 gap-3">
          <ImgBox className="flex-1" {...source[3]} />
          <div className="flex flex-1 gap-3 flex-col">
            <ImgBox className="flex-1" {...source[4]} />
            <ImgBox className="flex-1" {...source[5]} />
          </div>
        </div>
      </div>
    </div>
  );
};
const ItemB = ({ config }: any) => {
  const source = [...(config?.item_c || []), ...(config?.item_d || [])];
  return (
    <div className="box-border px-[9.38rem] py-40 justify-center flex items-center h-full relative ">
      <Image
        src={getSrc('1732003124830/item_a_bg')}
        alt=""
        fill
        className="object-fit absolute left-0 top-0 -z-10"
      />
      <div className=" h-full flex gap-x-3 max-h-[45rem] aspect-[22/9]">
        <div className="flex flex-col flex-1 gap-y-3">
          <div className="flex-1 overflow-hidden">
            <ImgBox {...source[0]} />
          </div>
          <div className="flex-1 flex gap-x-3 overflow-hidden">
            <ImgBox className="flex-1" {...source[1]} />
            <ImgBox className="flex-1" {...source[2]} />
          </div>
        </div>
        <div className=" flex flex-col flex-1 gap-y-3">
          <div className="flex-1 flex gap-x-3 overflow-hidden">
            <ImgBox className="flex-1" {...source[3]} />
            <ImgBox className="flex-1" {...source[4]} />
          </div>
          <div className="flex-1 overflow-hidden">
            <ImgBox {...source[5]} />
          </div>
        </div>
      </div>
    </div>
  );
};
const ItemNormal = ({ src, link }: { src: string; link: string }) => (
  <div
    className="w-full h-full bg-cover relative"
    style={{
      backgroundImage: `url(${getCosImageUrl(
        '/ssv-home/assets/images/good_case_bg.png'
      )})`,
    }}
  >
    <Link href={link ?? '/'} className="w-full h-full flex justify-center">
      <Image
        className="w-full max-w-screen-carousel cursor-pointer object-contain"
        src={src}
        alt=""
        width={1920}
        height={1080}
      />
    </Link>
    <div
      className="absolute w-full bottom-0 left-0 h-64"
      style={{
        backgroundImage:
          'linear-gradient(180deg, rgba(58, 58, 58, 0.00) 17.56%, #3A3A3A 100%)',
        opacity: 0.8,
      }}
    />
  </div>
);
interface IArrowGroup {
  onPrev: () => void;
  onNext: () => void;
}
const ArrowGroup = ({ onPrev, onNext }: IArrowGroup) => (
  <div className="absolute bottom-[5.25rem] px-[9.44rem] left-0 flex w-full h-10 items-center justify-between">
    <div className="flex flex-col items-center">
      <CosImage
        path="/ssv-home/app/home/desktop-section/images/carousel-arrow-left.png"
        fallbackSrc={carousel_arrow_left}
        alt=""
        className="w-10 h-10 cursor-pointer"
        onClick={onPrev}
      />
      <CosImage
        path="/ssv-home/app/home/desktop-section/images/arrow-line.png"
        fallbackSrc={arrow_line}
        alt=""
        className="w-32 h-1 mt-7"
      />
    </div>
    <div className="flex flex-col items-center">
      <CosImage
        path="/ssv-home/app/home/desktop-section/images/carousel-arrow-right.png"
        fallbackSrc={carousel_arrow_right}
        alt=""
        className="w-10 h-10 cursor-pointer"
        onClick={onNext}
      />
      <CosImage
        path="/ssv-home/app/home/desktop-section/images/arrow-line.png"
        fallbackSrc={arrow_line}
        alt=""
        className="w-32 h-1 mt-7"
      />
    </div>
  </div>
);
